import type { QueryClient } from "@tanstack/react-query";

/**
 * EVERY surface that shows a track follow-up or a track count, refreshed
 * together after ANY track write (re-date, status move, track added / removed,
 * member assigned):
 *   ["track-followups", …]  the dashboard rail's summary + lists, and the
 *                           drawer's per-lead rows (one prefix covers all)
 *   ["track-dashboard", …]  the Track pipeline + Track members cards
 *
 * One helper so a new write path cannot refresh the drawer and forget the
 * dashboard behind it — which is exactly how a follow-up re-dated to next week
 * stayed under "Today" until the page was reloaded (2026-09-20).
 */
export function invalidateTrackQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ["track-followups"] });
  queryClient.invalidateQueries({ queryKey: ["track-dashboard"] });
}
